import { render } from "./AuraHeader.vue?vue&type=template&id=61350fbc&scoped=true&ts=true"
import script from "./AuraHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraHeader.vue?vue&type=script&setup=true&lang=ts"

import "./AuraHeader.vue?vue&type=style&index=0&id=61350fbc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61350fbc"],['__file',"src/views/pages/aura/components/AuraHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61350fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61350fbc', __exports__)) {
    api.reload('61350fbc', __exports__)
  }
  
  module.hot.accept("./AuraHeader.vue?vue&type=template&id=61350fbc&scoped=true&ts=true", () => {
    api.rerender('61350fbc', render)
  })

}


export default __exports__